import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom'
import Dashboard from './pages/Dashboard'
import History from './pages/History'
import Admin from './pages/Admin'
import Login from './pages/Login'
import Signup from './pages/Signup'
import ProtectedRoute from './components/ProtectedRoute'
import { authService } from './services/auth'
import cargillsLogo from '/cargills_logo.png'

function AppContent() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const currentUser = authService.getCurrentUser();
    setUser(currentUser);
  }, []);

  const handleLogout = () => {
    authService.logout();
    setUser(null);
    navigate('/login');
  };

  const isAuthenticated = authService.isAuthenticated();

  return (
    <div className="app">
      {isAuthenticated && (
        <header className="header">
          <div className="header-content">
            <div className="header-left">
              <img src={cargillsLogo} alt="Cargills" className="header-logo" />
              <h1>Design Studio</h1>
            </div>
            <nav className="nav">
              <Link to="/" className="nav-link">Design Studio</Link>
              <Link to="/history" className="nav-link">History</Link>
              <Link to="/admin" className="nav-link">📊 Admin</Link>
            </nav>
            <div className="header-user">
              <span className="user-email">{user?.email}</span>
              <button onClick={handleLogout} className="logout-button">Logout</button>
            </div>
          </div>
        </header>
      )}

      <main className="main-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/history" element={
            <ProtectedRoute>
              <History />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          } />
        </Routes>
      </main>

      {isAuthenticated && (
        <footer className="footer">
          <p>&copy; 2026 Cargills Online. Automated Design Generation.</p>
        </footer>
      )}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}
